var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import AccessibilityNewOutlinedIcon from "@mui/icons-material/AccessibilityNewOutlined";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import AddBusinessOutlinedIcon from "@mui/icons-material/AddBusinessOutlined";
import AirportShuttleOutlinedIcon from "@mui/icons-material/AirportShuttleOutlined";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";
import ArchitectureOutlinedIcon from "@mui/icons-material/ArchitectureOutlined";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import BakeryDiningOutlinedIcon from "@mui/icons-material/BakeryDiningOutlined";
import BeachAccessOutlinedIcon from "@mui/icons-material/BeachAccessOutlined";
import BedOutlinedIcon from "@mui/icons-material/BedOutlined";
import BrunchDiningOutlinedIcon from "@mui/icons-material/BrunchDiningOutlined";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import CakeOutlinedIcon from "@mui/icons-material/CakeOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined";
import CastleOutlinedIcon from "@mui/icons-material/CastleOutlined";
import ChairOutlinedIcon from "@mui/icons-material/ChairOutlined";
import ChaletOutlinedIcon from "@mui/icons-material/ChaletOutlined";
import CheckroomOutlinedIcon from "@mui/icons-material/CheckroomOutlined";
import ChildCareOutlinedIcon from "@mui/icons-material/ChildCareOutlined";
import CleaningServicesOutlinedIcon from "@mui/icons-material/CleaningServicesOutlined";
import CoffeeOutlinedIcon from "@mui/icons-material/CoffeeOutlined";
import ColorLensOutlinedIcon from "@mui/icons-material/ColorLensOutlined";
import ConstructionOutlinedIcon from "@mui/icons-material/ConstructionOutlined";
import DeckOutlinedIcon from "@mui/icons-material/DeckOutlined";
import DirectionsBikeOutlinedIcon from "@mui/icons-material/DirectionsBikeOutlined";
import DirectionsBoatOutlinedIcon from "@mui/icons-material/DirectionsBoatOutlined";
import DirectionsBusOutlinedIcon from "@mui/icons-material/DirectionsBusOutlined";
import DirectionsCarOutlinedIcon from "@mui/icons-material/DirectionsCarOutlined";
import DownhillSkiingOutlinedIcon from "@mui/icons-material/DownhillSkiingOutlined";
import DryCleaningOutlinedIcon from "@mui/icons-material/DryCleaningOutlined";
import ElderlyOutlinedIcon from "@mui/icons-material/ElderlyOutlined";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import EscalatorWarningOutlinedIcon from "@mui/icons-material/EscalatorWarningOutlined";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import ExtensionOutlinedIcon from "@mui/icons-material/ExtensionOutlined";
import FaceRetouchingNaturalOutlinedIcon from "@mui/icons-material/FaceRetouchingNaturalOutlined";
import FamilyRestroomOutlinedIcon from "@mui/icons-material/FamilyRestroomOutlined";
import FastfoodOutlinedIcon from "@mui/icons-material/FastfoodOutlined";
import FestivalOutlinedIcon from "@mui/icons-material/FestivalOutlined";
import FitnessCenterOutlinedIcon from "@mui/icons-material/FitnessCenterOutlined";
import FlightOutlinedIcon from "@mui/icons-material/FlightOutlined";
import ForestOutlinedIcon from "@mui/icons-material/ForestOutlined";
import FreeBreakfastOutlinedIcon from "@mui/icons-material/FreeBreakfastOutlined";
import HealthAndSafetyOutlinedIcon from "@mui/icons-material/HealthAndSafetyOutlined";
import HikingOutlinedIcon from "@mui/icons-material/HikingOutlined";
import HomeRepairServiceOutlinedIcon from "@mui/icons-material/HomeRepairServiceOutlined";
import HotTubOutlinedIcon from "@mui/icons-material/HotTubOutlined";
import HotelOutlinedIcon from "@mui/icons-material/HotelOutlined";
import IceSkatingOutlinedIcon from "@mui/icons-material/IceSkatingOutlined";
import InterpreterModeOutlinedIcon from "@mui/icons-material/InterpreterModeOutlined";
import KayakingOutlinedIcon from "@mui/icons-material/KayakingOutlined";
import KingBedOutlinedIcon from "@mui/icons-material/KingBedOutlined";
import KitchenOutlinedIcon from "@mui/icons-material/KitchenOutlined";
import KitesurfingOutlinedIcon from "@mui/icons-material/KitesurfingOutlined";
import LandscapeOutlinedIcon from "@mui/icons-material/LandscapeOutlined";
import LocalActivityOutlinedIcon from "@mui/icons-material/LocalActivityOutlined";
import LocalBarOutlinedIcon from "@mui/icons-material/LocalBarOutlined";
import LocalCafeOutlinedIcon from "@mui/icons-material/LocalCafeOutlined";
import LocalDiningOutlinedIcon from "@mui/icons-material/LocalDiningOutlined";
import LocalFireDepartmentOutlinedIcon from "@mui/icons-material/LocalFireDepartmentOutlined";
import LocalFloristOutlinedIcon from "@mui/icons-material/LocalFloristOutlined";
import LocalHotelOutlinedIcon from "@mui/icons-material/LocalHotelOutlined";
import LocalLaundryServiceOutlinedIcon from "@mui/icons-material/LocalLaundryServiceOutlined";
import LocalLibraryOutlinedIcon from "@mui/icons-material/LocalLibraryOutlined";
import LocalMallOutlinedIcon from "@mui/icons-material/LocalMallOutlined";
import LocalMoviesOutlinedIcon from "@mui/icons-material/LocalMoviesOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import LocalParkingOutlinedIcon from "@mui/icons-material/LocalParkingOutlined";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import LocalPizzaOutlinedIcon from "@mui/icons-material/LocalPizzaOutlined";
import LocalSeeOutlinedIcon from "@mui/icons-material/LocalSeeOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import LocationCityOutlinedIcon from "@mui/icons-material/LocationCityOutlined";
import LuggageOutlinedIcon from "@mui/icons-material/LuggageOutlined";
import LunchDiningOutlinedIcon from "@mui/icons-material/LunchDiningOutlined";
import MuseumOutlinedIcon from "@mui/icons-material/MuseumOutlined";
import MusicNoteOutlinedIcon from "@mui/icons-material/MusicNoteOutlined";
import NightlifeOutlinedIcon from "@mui/icons-material/NightlifeOutlined";
import NordicWalkingOutlinedIcon from "@mui/icons-material/NordicWalkingOutlined";
import OutdoorGrillOutlinedIcon from "@mui/icons-material/OutdoorGrillOutlined";
import PaletteOutlinedIcon from "@mui/icons-material/PaletteOutlined";
import ParkOutlinedIcon from "@mui/icons-material/ParkOutlined";
import PedalBikeOutlinedIcon from "@mui/icons-material/PedalBikeOutlined";
import PetsOutlinedIcon from "@mui/icons-material/PetsOutlined";
import PianoOutlinedIcon from "@mui/icons-material/PianoOutlined";
import PoolOutlinedIcon from "@mui/icons-material/PoolOutlined";
import RestaurantOutlinedIcon from "@mui/icons-material/RestaurantOutlined";
import RestaurantMenuOutlinedIcon from "@mui/icons-material/RestaurantMenuOutlined";
import RoomServiceOutlinedIcon from "@mui/icons-material/RoomServiceOutlined";
import SailingOutlinedIcon from "@mui/icons-material/SailingOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import SelfImprovementOutlinedIcon from "@mui/icons-material/SelfImprovementOutlined";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import SnowboardingOutlinedIcon from "@mui/icons-material/SnowboardingOutlined";
import SnowshoeingOutlinedIcon from "@mui/icons-material/SnowshoeingOutlined";
import SpaOutlinedIcon from "@mui/icons-material/SpaOutlined";
import SportsOutlinedIcon from "@mui/icons-material/SportsOutlined";
import SportsBarOutlinedIcon from "@mui/icons-material/SportsBarOutlined";
import SportsBasketballOutlinedIcon from "@mui/icons-material/SportsBasketballOutlined";
import SportsEsportsOutlinedIcon from "@mui/icons-material/SportsEsportsOutlined";
import SportsFootballOutlinedIcon from "@mui/icons-material/SportsFootballOutlined";
import SportsGolfOutlinedIcon from "@mui/icons-material/SportsGolfOutlined";
import SportsGymnasticsOutlinedIcon from "@mui/icons-material/SportsGymnasticsOutlined";
import SportsHandballOutlinedIcon from "@mui/icons-material/SportsHandballOutlined";
import SportsKabaddiOutlinedIcon from "@mui/icons-material/SportsKabaddiOutlined";
import SportsMartialArtsOutlinedIcon from "@mui/icons-material/SportsMartialArtsOutlined";
import SportsMotorsportsOutlinedIcon from "@mui/icons-material/SportsMotorsportsOutlined";
import SportsSoccerOutlinedIcon from "@mui/icons-material/SportsSoccerOutlined";
import SportsTennisOutlinedIcon from "@mui/icons-material/SportsTennisOutlined";
import SurfingOutlinedIcon from "@mui/icons-material/SurfingOutlined";
import TheaterComedyOutlinedIcon from "@mui/icons-material/TheaterComedyOutlined";
import TourOutlinedIcon from "@mui/icons-material/TourOutlined";
import ToysOutlinedIcon from "@mui/icons-material/ToysOutlined";
import VolunteerActivismOutlinedIcon from "@mui/icons-material/VolunteerActivismOutlined";
import WineBarOutlinedIcon from "@mui/icons-material/WineBarOutlined";
import WorkOutlinedIcon from "@mui/icons-material/WorkOutlined";
import AcUnitOutlinedIcon from "@mui/icons-material/AcUnitOutlined";
import AgricultureOutlinedIcon from "@mui/icons-material/AgricultureOutlined";
import AttractionsOutlinedIcon from "@mui/icons-material/AttractionsOutlined";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import BalconyOutlinedIcon from "@mui/icons-material/BalconyOutlined";
import BathroomOutlinedIcon from "@mui/icons-material/BathroomOutlined";
import BathtubOutlinedIcon from "@mui/icons-material/BathtubOutlined";
import CabinOutlinedIcon from "@mui/icons-material/CabinOutlined";
import CelebrationOutlinedIcon from "@mui/icons-material/CelebrationOutlined";
import ChurchOutlinedIcon from "@mui/icons-material/ChurchOutlined";
import ContentCutOutlinedIcon from "@mui/icons-material/ContentCutOutlined";
import CottageOutlinedIcon from "@mui/icons-material/CottageOutlined";
import CountertopsOutlinedIcon from "@mui/icons-material/CountertopsOutlined";
import DiamondOutlinedIcon from "@mui/icons-material/DiamondOutlined";
import DinnerDiningOutlinedIcon from "@mui/icons-material/DinnerDiningOutlined";
import DirectionsRunOutlinedIcon from "@mui/icons-material/DirectionsRunOutlined";
import ElectricBikeOutlinedIcon from "@mui/icons-material/ElectricBikeOutlined";
import ElectricCarOutlinedIcon from "@mui/icons-material/ElectricCarOutlined";
import ElectricScooterOutlinedIcon from "@mui/icons-material/ElectricScooterOutlined";
import EngineeringOutlinedIcon from "@mui/icons-material/EngineeringOutlined";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
import FavoriteOutlinedIcon from "@mui/icons-material/FavoriteOutlined";
import FilterVintageOutlinedIcon from "@mui/icons-material/FilterVintageOutlined";
import FlatwareOutlinedIcon from "@mui/icons-material/FlatwareOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import HeadphonesOutlinedIcon from "@mui/icons-material/HeadphonesOutlined";
import HolidayVillageOutlinedIcon from "@mui/icons-material/HolidayVillageOutlined";
import HouseboatOutlinedIcon from "@mui/icons-material/HouseboatOutlined";
import KeyOutlinedIcon from "@mui/icons-material/KeyOutlined";
import LiquorOutlinedIcon from "@mui/icons-material/LiquorOutlined";
import LocalGroceryStoreOutlinedIcon from "@mui/icons-material/LocalGroceryStoreOutlined";
import LocalHospitalOutlinedIcon from "@mui/icons-material/LocalHospitalOutlined";
import LocalTaxiOutlinedIcon from "@mui/icons-material/LocalTaxiOutlined";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import MedicalServicesOutlinedIcon from "@mui/icons-material/MedicalServicesOutlined";
import MeetingRoomOutlinedIcon from "@mui/icons-material/MeetingRoomOutlined";
import MicOutlinedIcon from "@mui/icons-material/MicOutlined";
import NightShelterOutlinedIcon from "@mui/icons-material/NightShelterOutlined";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import PinDropOutlinedIcon from "@mui/icons-material/PinDropOutlined";
import PlumbingOutlinedIcon from "@mui/icons-material/PlumbingOutlined";
import PublicOutlinedIcon from "@mui/icons-material/PublicOutlined";
import RamenDiningOutlinedIcon from "@mui/icons-material/RamenDiningOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import RedeemOutlinedIcon from "@mui/icons-material/RedeemOutlined";
import RollerSkatingOutlinedIcon from "@mui/icons-material/RollerSkatingOutlined";
import RoofingOutlinedIcon from "@mui/icons-material/RoofingOutlined";
import SanitizerOutlinedIcon from "@mui/icons-material/SanitizerOutlined";
import ScubaDivingOutlinedIcon from "@mui/icons-material/ScubaDivingOutlined";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import ShowerOutlinedIcon from "@mui/icons-material/ShowerOutlined";
import SkateboardingOutlinedIcon from "@mui/icons-material/SkateboardingOutlined";
import SportsCricketOutlinedIcon from "@mui/icons-material/SportsCricketOutlined";
import SportsHockeyOutlinedIcon from "@mui/icons-material/SportsHockeyOutlined";
import SportsRugbyOutlinedIcon from "@mui/icons-material/SportsRugbyOutlined";
import SportsVolleyballOutlinedIcon from "@mui/icons-material/SportsVolleyballOutlined";
import StadiumOutlinedIcon from "@mui/icons-material/StadiumOutlined";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import TableBarOutlinedIcon from "@mui/icons-material/TableBarOutlined";
import TakeoutDiningOutlinedIcon from "@mui/icons-material/TakeoutDiningOutlined";
import TapasOutlinedIcon from "@mui/icons-material/TapasOutlined";
import TempleBuddhistOutlinedIcon from "@mui/icons-material/TempleBuddhistOutlined";
import TempleHinduOutlinedIcon from "@mui/icons-material/TempleHinduOutlined";
import TerrainOutlinedIcon from "@mui/icons-material/TerrainOutlined";
import TrainOutlinedIcon from "@mui/icons-material/TrainOutlined";
import TramOutlinedIcon from "@mui/icons-material/TramOutlined";
import TwoWheelerOutlinedIcon from "@mui/icons-material/TwoWheelerOutlined";
import VillaOutlinedIcon from "@mui/icons-material/VillaOutlined";
import WaterOutlinedIcon from "@mui/icons-material/WaterOutlined";
import WaterDropOutlinedIcon from "@mui/icons-material/WaterDropOutlined";
import WavesOutlinedIcon from "@mui/icons-material/WavesOutlined";
import WbSunnyOutlinedIcon from "@mui/icons-material/WbSunnyOutlined";
import WeekendOutlinedIcon from "@mui/icons-material/WeekendOutlined";
import WheelchairPickupOutlinedIcon from "@mui/icons-material/WheelchairPickupOutlined";
import WifiOutlinedIcon from "@mui/icons-material/WifiOutlined";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import { SectorType } from "../../models/sector/sector.model";
import { ADDITIONAL_MUI_SECTOR_ICONS } from "./additionalMuiSectorIcons";
import { ChildHatIcon, FamilyRestroomIcon as CustomFamilyRestroomIcon, FertileIcon, HighChairIcon, HorseIcon, } from "./customSectorIcons";
import { GOOGLE_MATERIAL_SYMBOL_SECTOR_ICONS } from "./googleMaterialSymbolSectorIcons";
export var DEFAULT_SECTOR_ICON_KEY_BY_TYPE = (_a = {},
    _a[SectorType.ACCOMMODATION] = "hotel",
    _a[SectorType.RESTAURANT] = "restaurant",
    _a[SectorType.SPA] = "spa",
    _a[SectorType.WEEKLY_PLANNER] = "calendar",
    _a[SectorType.OTHER] = "event",
    _a);
var icon = function (key, label, search, Icon) { return ({ key: key, label: label, search: search, Icon: Icon }); };
export var SECTOR_ICON_OPTIONS = __spreadArray(__spreadArray([
    icon("default", "Default", "default fallback calendar event", EventOutlinedIcon),
    icon("accessibility", "Accessibility", "accessibility wheelchair inclusive", AccessibilityNewOutlinedIcon),
    icon("account-tree", "Structure", "structure hierarchy connected tree", AccountTreeOutlinedIcon),
    icon("business", "Business", "business company shop store", AddBusinessOutlinedIcon),
    icon("shuttle", "Shuttle", "shuttle transfer bus transport", AirportShuttleOutlinedIcon),
    icon("apartment", "Apartment", "apartment building accommodation", ApartmentOutlinedIcon),
    icon("architecture", "Architecture", "architecture design drawing plan", ArchitectureOutlinedIcon),
    icon("special", "Special", "special magic sparkle", AutoAwesomeOutlinedIcon),
    icon("bakery", "Bakery", "bakery bread pastry", BakeryDiningOutlinedIcon),
    icon("beach", "Beach", "beach holiday summer umbrella", BeachAccessOutlinedIcon),
    icon("bed", "Bed", "bed room sleep accommodation", BedOutlinedIcon),
    icon("brunch", "Brunch", "brunch breakfast food dining", BrunchDiningOutlinedIcon),
    icon("briefcase", "Briefcase", "briefcase work business office", BusinessCenterOutlinedIcon),
    icon("cake", "Cake", "cake birthday dessert", CakeOutlinedIcon),
    icon("calendar", "Calendar", "calendar agenda weekly planner event", CalendarMonthOutlinedIcon),
    icon("camera", "Camera", "camera photo photography", CameraAltOutlinedIcon),
    icon("castle", "Castle", "castle landmark building", CastleOutlinedIcon),
    icon("chair", "Chair", "chair seating table", ChairOutlinedIcon),
    icon("chalet", "Chalet", "chalet cabin mountain accommodation", ChaletOutlinedIcon),
    icon("wardrobe", "Wardrobe", "wardrobe clothes rental dressing", CheckroomOutlinedIcon),
    icon("kids", "Kids", "kids child children family", ChildCareOutlinedIcon),
    icon("child-hat", "Child hat", "child hat baby kids children family", ChildHatIcon),
    icon("cleaning", "Cleaning", "cleaning housekeeping broom", CleaningServicesOutlinedIcon),
    icon("coffee", "Coffee", "coffee cafe tea", CoffeeOutlinedIcon),
    icon("creative", "Creative", "creative color paint art", ColorLensOutlinedIcon),
    icon("construction", "Construction", "construction repair maintenance", ConstructionOutlinedIcon),
    icon("terrace", "Terrace", "terrace deck outdoor garden", DeckOutlinedIcon),
    icon("bike", "Bike", "bike cycling bicycle", DirectionsBikeOutlinedIcon),
    icon("boat", "Boat", "boat ship lake water", DirectionsBoatOutlinedIcon),
    icon("bus", "Bus", "bus transport transfer", DirectionsBusOutlinedIcon),
    icon("car", "Car", "car parking transfer transport", DirectionsCarOutlinedIcon),
    icon("ski", "Ski", "ski skiing winter snow", DownhillSkiingOutlinedIcon),
    icon("dry-cleaning", "Dry cleaning", "dry cleaning laundry clothes", DryCleaningOutlinedIcon),
    icon("senior", "Senior", "senior elderly care", ElderlyOutlinedIcon),
    icon("trophy", "Trophy", "trophy award competition winner", EmojiEventsOutlinedIcon),
    icon("family", "Family", "family parents children", EscalatorWarningOutlinedIcon),
    icon("family-restroom", "Family restroom", "family restroom parents children toilet", CustomFamilyRestroomIcon),
    icon("event", "Event", "event reservation date", EventOutlinedIcon),
    icon("puzzle", "Puzzle", "puzzle game activity", ExtensionOutlinedIcon),
    icon("beauty", "Beauty", "beauty face cosmetics", FaceRetouchingNaturalOutlinedIcon),
    icon("restroom", "Restroom", "restroom family toilet", FamilyRestroomOutlinedIcon),
    icon("fast-food", "Fast food", "fast food burger snack", FastfoodOutlinedIcon),
    icon("festival", "Festival", "festival tent event", FestivalOutlinedIcon),
    icon("fertile", "Fertile", "fertile fertility nature", FertileIcon),
    icon("fitness", "Fitness", "fitness gym workout sport", FitnessCenterOutlinedIcon),
    icon("flight", "Flight", "flight airport travel", FlightOutlinedIcon),
    icon("forest", "Forest", "forest nature outdoor", ForestOutlinedIcon),
    icon("breakfast", "Breakfast", "breakfast coffee morning", FreeBreakfastOutlinedIcon),
    icon("health", "Health", "health safety medical", HealthAndSafetyOutlinedIcon),
    icon("high-chair", "High chair", "high chair baby infant child kids restaurant", HighChairIcon),
    icon("hiking", "Hiking", "hiking walk mountain outdoor", HikingOutlinedIcon),
    icon("repair", "Repair", "repair service tools", HomeRepairServiceOutlinedIcon),
    icon("hot-tub", "Hot tub", "hot tub spa wellness", HotTubOutlinedIcon),
    icon("hotel", "Hotel", "hotel accommodation room stay", HotelOutlinedIcon),
    icon("ice-skating", "Ice skating", "ice skating winter sport", IceSkatingOutlinedIcon),
    icon("guide", "Guide", "guide reception concierge", InterpreterModeOutlinedIcon),
    icon("kayak", "Kayak", "kayak water sport lake", KayakingOutlinedIcon),
    icon("king-bed", "King bed", "king bed hotel room sleep", KingBedOutlinedIcon),
    icon("kitchen", "Kitchen", "kitchen cooking food", KitchenOutlinedIcon),
    icon("kitesurfing", "Kitesurfing", "kitesurfing water wind sport", KitesurfingOutlinedIcon),
    icon("landscape", "Landscape", "landscape mountain view", LandscapeOutlinedIcon),
    icon("ticket", "Ticket", "ticket activity voucher", LocalActivityOutlinedIcon),
    icon("bar", "Bar", "bar drink cocktail", LocalBarOutlinedIcon),
    icon("cafe", "Cafe", "cafe coffee tea", LocalCafeOutlinedIcon),
    icon("dining", "Dining", "dining food restaurant meal", LocalDiningOutlinedIcon),
    icon("fireplace", "Fireplace", "fire fireplace heat", LocalFireDepartmentOutlinedIcon),
    icon("nature", "Nature", "nature flower garden", LocalFloristOutlinedIcon),
    icon("local-hotel", "Local hotel", "hotel bed accommodation", LocalHotelOutlinedIcon),
    icon("laundry", "Laundry", "laundry washing", LocalLaundryServiceOutlinedIcon),
    icon("library", "Library", "library reading learning", LocalLibraryOutlinedIcon),
    icon("shopping", "Shopping", "shopping mall shop", LocalMallOutlinedIcon),
    icon("movies", "Movies", "movie cinema theater", LocalMoviesOutlinedIcon),
    icon("offer", "Offer", "offer tag discount", LocalOfferOutlinedIcon),
    icon("parking", "Parking", "parking car", LocalParkingOutlinedIcon),
    icon("phone", "Phone", "phone call contact", LocalPhoneOutlinedIcon),
    icon("pizza", "Pizza", "pizza food restaurant", LocalPizzaOutlinedIcon),
    icon("photo", "Photo", "photo camera view", LocalSeeOutlinedIcon),
    icon("shipping", "Shipping", "shipping delivery truck", LocalShippingOutlinedIcon),
    icon("city", "City", "city building location", LocationCityOutlinedIcon),
    icon("luggage", "Luggage", "luggage baggage travel", LuggageOutlinedIcon),
    icon("lunch", "Lunch", "lunch burger dining", LunchDiningOutlinedIcon),
    icon("museum", "Museum", "museum culture gallery", MuseumOutlinedIcon),
    icon("music", "Music", "music concert sound", MusicNoteOutlinedIcon),
    icon("nightlife", "Nightlife", "nightlife party club", NightlifeOutlinedIcon),
    icon("walking", "Walking", "walking nordic outdoor", NordicWalkingOutlinedIcon),
    icon("grill", "Grill", "grill barbecue food", OutdoorGrillOutlinedIcon),
    icon("palette", "Palette", "palette art creative", PaletteOutlinedIcon),
    icon("park", "Park", "park tree garden", ParkOutlinedIcon),
    icon("pedal-bike", "Pedal bike", "pedal bike cycling", PedalBikeOutlinedIcon),
    icon("pets", "Pets", "pets dog animal", PetsOutlinedIcon),
    icon("piano", "Piano", "piano music instrument", PianoOutlinedIcon),
    icon("pool", "Pool", "pool swimming water", PoolOutlinedIcon),
    icon("food", "Food", "food restaurant meal", RestaurantOutlinedIcon),
    icon("restaurant", "Restaurant", "restaurant dining food table", RestaurantMenuOutlinedIcon),
    icon("room-service", "Room service", "room service hotel", RoomServiceOutlinedIcon),
    icon("sailing", "Sailing", "sailing boat water", SailingOutlinedIcon),
    icon("school", "School", "school learning class", SchoolOutlinedIcon),
    icon("yoga", "Yoga", "yoga meditation relax wellness", SelfImprovementOutlinedIcon),
    icon("shopping-bag", "Shopping bag", "shopping bag retail", ShoppingBagOutlinedIcon),
    icon("snowboard", "Snowboard", "snowboard winter snow sport", SnowboardingOutlinedIcon),
    icon("snowshoe", "Snowshoe", "snowshoe winter snow hiking", SnowshoeingOutlinedIcon),
    icon("spa", "Spa", "spa wellness beauty massage sauna", SpaOutlinedIcon),
    icon("sports", "Sports", "sports general activity", SportsOutlinedIcon),
    icon("sports-bar", "Sports bar", "sports bar drink", SportsBarOutlinedIcon),
    icon("basketball", "Basketball", "basketball sport", SportsBasketballOutlinedIcon),
    icon("esports", "Esports", "esports game gaming", SportsEsportsOutlinedIcon),
    icon("football", "Football", "football sport", SportsFootballOutlinedIcon),
    icon("golf", "Golf", "golf sport course", SportsGolfOutlinedIcon),
    icon("gymnastics", "Gymnastics", "gymnastics movement sport", SportsGymnasticsOutlinedIcon),
    icon("handball", "Handball", "handball volleyball sport", SportsHandballOutlinedIcon),
    icon("active-sport", "Active sport", "active sport movement", SportsKabaddiOutlinedIcon),
    icon("martial-arts", "Martial arts", "martial arts boxing fighting sport", SportsMartialArtsOutlinedIcon),
    icon("motorsport", "Motorsport", "motorsport racing motorbike", SportsMotorsportsOutlinedIcon),
    icon("soccer", "Soccer", "soccer football sport", SportsSoccerOutlinedIcon),
    icon("tennis", "Tennis", "tennis court racket sport", SportsTennisOutlinedIcon),
    icon("surfing", "Surfing", "surfing water wave sport", SurfingOutlinedIcon),
    icon("stage", "Stage", "stage theater performance", TheaterComedyOutlinedIcon),
    icon("tour", "Tour", "tour flag guide", TourOutlinedIcon),
    icon("toys", "Toys", "toys kids play", ToysOutlinedIcon),
    icon("horse", "Horse", "horse riding stable reiten", HorseIcon),
    icon("volunteer", "Volunteer", "volunteer charity care", VolunteerActivismOutlinedIcon),
    icon("wine", "Wine", "wine bar drink", WineBarOutlinedIcon),
    icon("work", "Work", "work business office", WorkOutlinedIcon),
    icon("air-conditioning", "Air conditioning", "air conditioning climate cooling snow", AcUnitOutlinedIcon),
    icon("farm", "Farm", "farm agriculture tractor countryside", AgricultureOutlinedIcon),
    icon("attraction", "Attraction", "attraction amusement theme park ride", AttractionsOutlinedIcon),
    icon("badge", "Badge", "badge staff employee identification", BadgeOutlinedIcon),
    icon("balcony", "Balcony", "balcony terrace room outdoor", BalconyOutlinedIcon),
    icon("bathroom", "Bathroom", "bathroom restroom washroom", BathroomOutlinedIcon),
    icon("bathtub", "Bathtub", "bathtub bath spa wellness", BathtubOutlinedIcon),
    icon("cabin", "Cabin", "cabin lodge hut accommodation", CabinOutlinedIcon),
    icon("celebration", "Celebration", "celebration party confetti event", CelebrationOutlinedIcon),
    icon("church", "Church", "church chapel wedding ceremony", ChurchOutlinedIcon),
    icon("salon", "Salon", "salon hairdresser haircut scissors beauty", ContentCutOutlinedIcon),
    icon("cottage", "Cottage", "cottage house holiday accommodation", CottageOutlinedIcon),
    icon("counter", "Counter", "counter kitchen countertop workspace", CountertopsOutlinedIcon),
    icon("diamond", "Diamond", "diamond luxury premium jewellery", DiamondOutlinedIcon),
    icon("dinner", "Dinner", "dinner dining restaurant evening meal", DinnerDiningOutlinedIcon),
    icon("running", "Running", "running jogging fitness sport", DirectionsRunOutlinedIcon),
    icon("electric-bike", "Electric bike", "electric bike bicycle mobility", ElectricBikeOutlinedIcon),
    icon("electric-car", "Electric car", "electric car vehicle charging transport", ElectricCarOutlinedIcon),
    icon("scooter", "Scooter", "electric scooter mobility transport", ElectricScooterOutlinedIcon),
    icon("engineering", "Engineering", "engineering technician maintenance service", EngineeringOutlinedIcon),
    icon("availability", "Availability", "availability calendar confirmed appointment", EventAvailableOutlinedIcon),
    icon("favorite", "Favorite", "favorite heart love", FavoriteOutlinedIcon),
    icon("flower", "Flower", "flower garden nature vintage", FilterVintageOutlinedIcon),
    icon("flatware", "Flatware", "flatware cutlery dining restaurant meal", FlatwareOutlinedIcon),
    icon("group", "Group", "group people guests team", GroupsOutlinedIcon),
    icon("handshake", "Handshake", "handshake partnership welcome agreement", HandshakeOutlinedIcon),
    icon("headphones", "Headphones", "headphones audio music listening", HeadphonesOutlinedIcon),
    icon("holiday-village", "Holiday village", "holiday village resort accommodation", HolidayVillageOutlinedIcon),
    icon("houseboat", "Houseboat", "houseboat boat accommodation water", HouseboatOutlinedIcon),
    icon("key", "Key", "key room access security", KeyOutlinedIcon),
    icon("liquor", "Liquor", "liquor spirits bottle bar drink", LiquorOutlinedIcon),
    icon("grocery", "Grocery", "grocery store market shopping food", LocalGroceryStoreOutlinedIcon),
    icon("hospital", "Hospital", "hospital clinic health emergency", LocalHospitalOutlinedIcon),
    icon("taxi", "Taxi", "taxi cab transfer car transport", LocalTaxiOutlinedIcon),
    icon("map", "Map", "map travel location guide", MapOutlinedIcon),
    icon("medical-services", "Medical services", "medical services doctor clinic health", MedicalServicesOutlinedIcon),
    icon("meeting-room", "Meeting room", "meeting room conference business door", MeetingRoomOutlinedIcon),
    icon("microphone", "Microphone", "microphone music speech karaoke event", MicOutlinedIcon),
    icon("shelter", "Shelter", "shelter hostel accommodation bed", NightShelterOutlinedIcon),
    icon("payment", "Payment", "payment money price billing", PaidOutlinedIcon),
    icon("people", "People", "people guests visitors profiles", PeopleOutlinedIcon),
    icon("location", "Location", "location pin place destination", PinDropOutlinedIcon),
    icon("plumbing", "Plumbing", "plumbing maintenance pipe repair", PlumbingOutlinedIcon),
    icon("world", "World", "world globe international public travel", PublicOutlinedIcon),
    icon("ramen", "Ramen", "ramen noodles soup asian food restaurant", RamenDiningOutlinedIcon),
    icon("invoice", "Invoice", "invoice receipt billing folio document", ReceiptLongOutlinedIcon),
    icon("gift", "Gift", "gift present voucher redeem", RedeemOutlinedIcon),
    icon("roller-skating", "Roller skating", "roller skating sport activity", RollerSkatingOutlinedIcon),
    icon("roof", "Roof", "roof house accommodation building", RoofingOutlinedIcon),
    icon("hygiene", "Hygiene", "hygiene sanitizer clean health", SanitizerOutlinedIcon),
    icon("scuba-diving", "Scuba diving", "scuba diving underwater sport", ScubaDivingOutlinedIcon),
    icon("security", "Security", "security shield protection safe", SecurityOutlinedIcon),
    icon("shower", "Shower", "shower bathroom spa wellness", ShowerOutlinedIcon),
    icon("skateboarding", "Skateboarding", "skateboarding board sport activity", SkateboardingOutlinedIcon),
    icon("cricket", "Cricket", "cricket bat ball sport", SportsCricketOutlinedIcon),
    icon("hockey", "Hockey", "hockey ice sport", SportsHockeyOutlinedIcon),
    icon("rugby", "Rugby", "rugby ball sport", SportsRugbyOutlinedIcon),
    icon("volleyball", "Volleyball", "volleyball beach ball sport", SportsVolleyballOutlinedIcon),
    icon("stadium", "Stadium", "stadium arena sport event", StadiumOutlinedIcon),
    icon("storefront", "Storefront", "storefront shop retail business", StorefrontOutlinedIcon),
    icon("table-bar", "Table and bar", "table bar restaurant seating", TableBarOutlinedIcon),
    icon("takeaway", "Takeaway", "takeaway takeout food restaurant", TakeoutDiningOutlinedIcon),
    icon("tapas", "Tapas", "tapas small plates food restaurant", TapasOutlinedIcon),
    icon("buddhist-temple", "Buddhist temple", "buddhist temple meditation spiritual", TempleBuddhistOutlinedIcon),
    icon("hindu-temple", "Hindu temple", "hindu temple spiritual", TempleHinduOutlinedIcon),
    icon("terrain", "Terrain", "terrain mountain landscape outdoor", TerrainOutlinedIcon),
    icon("train", "Train", "train railway transport transfer", TrainOutlinedIcon),
    icon("tram", "Tram", "tram railway city transport", TramOutlinedIcon),
    icon("motorbike", "Motorbike", "motorbike motorcycle transport", TwoWheelerOutlinedIcon),
    icon("villa", "Villa", "villa resort house accommodation", VillaOutlinedIcon),
    icon("water", "Water", "water lake sea pool", WaterOutlinedIcon),
    icon("water-drop", "Water drop", "water drop hydration spa", WaterDropOutlinedIcon),
    icon("waves", "Waves", "waves water sea ocean spa", WavesOutlinedIcon),
    icon("sunny", "Sunny", "sunny sun weather outdoor summer", WbSunnyOutlinedIcon),
    icon("lounge", "Lounge", "lounge sofa weekend seating relax", WeekendOutlinedIcon),
    icon("wheelchair", "Wheelchair", "wheelchair accessible inclusive mobility", WheelchairPickupOutlinedIcon),
    icon("wifi", "Wi-Fi", "wifi internet wireless connection", WifiOutlinedIcon),
    icon("premium", "Premium", "premium award quality luxury", WorkspacePremiumOutlinedIcon)
], GOOGLE_MATERIAL_SYMBOL_SECTOR_ICONS, true), ADDITIONAL_MUI_SECTOR_ICONS, true);
export var getSectorIconOption = function (key) {
    if (!key)
        return undefined;
    return SECTOR_ICON_OPTIONS.find(function (option) { return option.key === key; });
};
export var getSectorIcon = function (sector) {
    var option = getSectorIconOption((sector === null || sector === void 0 ? void 0 : sector.sidebarIconKey)
        || ((sector === null || sector === void 0 ? void 0 : sector.sectorType) ? DEFAULT_SECTOR_ICON_KEY_BY_TYPE[sector.sectorType] : undefined));
    return option === null || option === void 0 ? void 0 : option.Icon;
};
